function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.reflect.get.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { Control, Rotate, Zoom as BaseZoom } from "ol/control";
import { CLASS_UNSELECTABLE, CLASS_CONTROL } from "ol/css";
import ViewHint from "ol/ViewHint";
import { clamp } from "ol/math";
import { MapEvent } from "ol";
import { addResizeListener } from "../legacy/detect-element-resize";
import pointer from "./pointer_images";
import { createElement } from "@maplat/core";
var control_settings = {};
var delegator = {
  compass: "compass.png",
  border: "border.png",
  attr: "attr.png",
  gps: "gps.png",
  zoom_plus: "plus.png",
  zoom_minus: "minus.png",
  help: "help.png",
  home: "home.png",
  hide_marker: "hide_marker.png",
  share: "share.png",
  slider_in_help: "slider.png",
  favicon: "favicon.png"
};
function hexRgb(hex) {
  var ret = {};
  if (hex.match(/^#?([0-9A-F]{2})([0-9A-F]{2})([0-9A-F]{2})$/i)) {
    ret.red = parseInt(RegExp.$1, 16);
    ret.green = parseInt(RegExp.$2, 16);
    ret.blue = parseInt(RegExp.$3, 16);
  } else if (hex.match(/^#?([0-9A-F])([0-9A-F])([0-9A-F])$/i)) {
    ret.red = parseInt("".concat(RegExp.$1).concat(RegExp.$1), 16);
    ret.green = parseInt("".concat(RegExp.$2).concat(RegExp.$2), 16);
    ret.blue = parseInt("".concat(RegExp.$3).concat(RegExp.$3), 16);
  }
  return ret;
}
export function setControlSettings(options) {
  control_settings = options;
  Object.keys(control_settings).forEach(function (key) {
    if (delegator[key]) {
      pointer[delegator[key]] = control_settings[key];
    }
  });
}

/**
 * @classdesc
 * A slider type of control for zooming.
 *
 * Example:
 *
 *     map.addControl(new ol.control.SliderCommon());
 *
 * @constructor
 * @extends {ol.control.Control}
 * @param {olx.control.SliderCommonOptions=} opt_options Zoom slider options.
 * @api
 */
export var SliderCommon = /*#__PURE__*/function (_Control) {
  _inherits(SliderCommon, _Control);
  var _super = _createSuper(SliderCommon);
  function SliderCommon(opt_options) {
    var _this;
    _classCallCheck(this, SliderCommon);
    var options = opt_options ? opt_options : {};
    var containerElement = document.createElement("div"); // eslint-disable-line no-undef
    var render = options.render ? options.render : SliderCommon.render;
    _this = _super.call(this, {
      element: containerElement,
      render: render
    });

    /**
     * The direction of the slider. Will be determined from actual display of the
     * container and defaults to ol.control.SliderCommon.Direction_.VERTICAL.
     *
     * @type {ol.control.SliderCommon.Direction_}
     * @private
     */
    _this.direction_ = SliderCommon.Direction_.VERTICAL;

    /**
     * @type {boolean}
     * @private
     */
    _this.dragging_ = undefined;
    _this.value_ = undefined;

    /**
     * @type {number|undefined}
     * @private
     */
    _this.previousX_ = undefined;

    /**
     * @type {number|undefined}
     * @private
     */
    _this.previousY_ = undefined;

    /**
     * The calculated thumb size (border box plus margins).  Set when initSlider_
     * is called.
     * @type {ol.Size}
     * @private
     */
    _this.thumbSize_ = null;

    /**
     * Whether the slider is initialized.
     * @type {boolean}
     * @private
     */
    _this.sliderInitialized_ = false;

    /**
     * @type {number}
     * @private
     */
    _this.duration_ = options.duration !== undefined ? options.duration : 200;

    /**
     * @type {number}
     * @private
     */
    _this.reverse_ = options.reverse !== undefined ? options.reverse : false;
    _this.initialValue = options.initialValue;
    var className = options.className !== undefined ? options.className : "ol-slidercommon";
    var thumbElement = document.createElement("button"); // eslint-disable-line no-undef
    thumbElement.setAttribute("type", "button");
    thumbElement.className = "".concat(className, "-thumb").concat(CLASS_UNSELECTABLE);
    containerElement.title = options.tipLabel;
    containerElement.className = "".concat(className, " ").concat(CLASS_UNSELECTABLE, " ").concat(CLASS_CONTROL);
    containerElement.appendChild(thumbElement);

    /**
     * @type {ol.pointer.PointerEventHandler}
     * @private
     */
    containerElement.addEventListener("pointerdown", function (ev) {
      ev.stopPropagation();
      _this.handleDraggerStart_(ev);
    });
    containerElement.addEventListener("pointermove", function (ev) {
      ev.stopPropagation();
      _this.handleDraggerDrag_(ev);
    });
    containerElement.addEventListener("pointerup", function (ev) {
      ev.stopPropagation();
      _this.handleDraggerEnd_(ev);
    });
    thumbElement.addEventListener("click", function (ev) {
      ev.stopPropagation();
    });
    containerElement.addEventListener("mouseout", function (ev) {
      ev.stopPropagation();
      _this.handleDraggerEnd_(ev);
    });
    if (control_settings["slider_color"]) {
      var rgb = hexRgb(control_settings["slider_color"]);
      var button = _this.element.querySelector("button");
      button.addEventListener("mouseover", function () {
        button.style.backgroundColor = "rgba(".concat(rgb.red, ",").concat(rgb.green, ",").concat(rgb.blue, ",.7)");
      });
      button.addEventListener("mouseout", function () {
        var disable = _this.element.classList.contains("disable");
        button.style.backgroundColor = "rgba(".concat(rgb.red, ",").concat(rgb.green, ",").concat(rgb.blue, ",").concat(disable ? 0.2 : 0.5, ")");
      });
    }
    return _this;
  }

  /**
   * Update the SliderCommon element.
   * @param {ol.MapEvent} mapEvent Map event.
   * @this {ol.control.SliderCommon}
   * @api
   */
  _createClass(SliderCommon, [{
    key: "disposeInternal",
    value:
    /**
     * @inheritDoc
     */
    function disposeInternal() {
      this.dragger_.dispose();
      _get(_getPrototypeOf(SliderCommon.prototype), "disposeInternal", this).call(this);
    }

    /**
     * @inheritDoc
     */
  }, {
    key: "setMap",
    value: function setMap(map) {
      _get(_getPrototypeOf(SliderCommon.prototype), "setMap", this).call(this, map);
      if (map) {
        map.render();
      }
    }

    /**
     * Initializes the slider element. This will determine and set this controls
     * direction_ and also constrain the dragging of the thumb to always be within
     * the bounds of the container.
     *
     * @private
     */
  }, {
    key: "initSlider_",
    value: function initSlider_() {
      var container = this.element;
      var containerSize = {
        width: container.offsetWidth,
        height: container.offsetHeight
      };
      var thumb = container.firstElementChild;
      var computedStyle = getComputedStyle(thumb); // eslint-disable-line no-undef
      var thumbWidth = thumb.offsetWidth + parseFloat(computedStyle["marginRight"]) + parseFloat(computedStyle["marginLeft"]);
      var thumbHeight = thumb.offsetHeight + parseFloat(computedStyle["marginTop"]) + parseFloat(computedStyle["marginBottom"]);
      this.thumbSize_ = [thumbWidth, thumbHeight];
      if (containerSize.width > containerSize.height) {
        this.direction_ = SliderCommon.Direction_.HORIZONTAL;
      } else {
        this.direction_ = SliderCommon.Direction_.VERTICAL;
      }
      this.setValue(this.initialValue || 0);
      var self = this;
      addResizeListener(container, function () {
        self.setValue(self.value_);
      });
      this.sliderInitialized_ = true;
    }
  }, {
    key: "widthLimit_",
    value: function widthLimit_(_event) {
      var container = this.element;
      return container.offsetWidth - this.thumbSize_[0];
    }
  }, {
    key: "heightLimit_",
    value: function heightLimit_(_event) {
      var container = this.element;
      return container.offsetHeight - this.thumbSize_[1];
    }

    /**
     * @param {Event} event The browser event to handle.
     * @private
     */
  }, {
    key: "handleContainerClick_",
    value: function handleContainerClick_(event) {
      var relativePosition = this.getRelativePosition_(event.offsetX - this.thumbSize_[0] / 2, event.offsetY - this.thumbSize_[1] / 2);
      this.setThumbPosition_(relativePosition);
    }

    /**
     * Handle dragger start events.
     * @param {ol.pointer.PointerEvent} event The drag event.
     * @private
     */
  }, {
    key: "handleDraggerStart_",
    value: function handleDraggerStart_(event) {
      if (!this.dragging_ && event.target === this.element.firstElementChild && !this.element.classList.contains("disable")) {
        this.getMap().getView().setHint(ViewHint.INTERACTING, 1);
        this.previousX_ = event.clientX;
        this.previousY_ = event.clientY;
        this.dragging_ = true;
      }
    }

    /**
     * Handle dragger drag events.
     *
     * @param {ol.pointer.PointerEvent|Event} event The drag event.
     * @private
     */
  }, {
    key: "handleDraggerDrag_",
    value: function handleDraggerDrag_(event) {
      if (this.dragging_) {
        var element = this.element.firstElementChild;
        var deltaX = event.clientX - this.previousX_ + (parseFloat(element.style.left, 10) || 0);
        var deltaY = event.clientY - this.previousY_ + (parseFloat(element.style.top, 10) || 0);
        var relativePosition = this.getRelativePosition_(deltaX, deltaY);
        this.setThumbPosition_(relativePosition);
        this.previousX_ = event.clientX;
        this.previousY_ = event.clientY;
      }
    }

    /**
     * Handle dragger end events.
     * @param {ol.pointer.PointerEvent|Event} event The drag event.
     * @private
     */
  }, {
    key: "handleDraggerEnd_",
    value: function handleDraggerEnd_(_event) {
      if (this.dragging_) {
        var view = this.getMap().getView();
        view.setHint(ViewHint.INTERACTING, -1);
        this.dragging_ = false;
        this.previousX_ = undefined;
        this.previousY_ = undefined;
      }
    }

    /**
     * Positions the thumb inside its container according to the given resolution.
     *
     * @param {number} res The res.
     * @private
     */
  }, {
    key: "setThumbPosition_",
    value: function setThumbPosition_(res) {
      var thumb = this.element.firstElementChild;
      if (this.direction_ == SliderCommon.Direction_.HORIZONTAL) {
        thumb.style.left = "".concat(this.widthLimit_() * res, "px");
      } else {
        thumb.style.top = "".concat(this.heightLimit_() * res, "px");
      }
      this.value_ = this.reverse_ ? 1 - res : res;
      this.set("slidervalue", this.value_);
    }

    /**
     * Calculates the relative position of the thumb given x and y offsets.  The
     * relative position scales from 0 to 1.  The x and y offsets are assumed to be
     * in pixel units within the dragger limits.
     *
     * @param {number} x Pixel position relative to the left of the slider.
     * @param {number} y Pixel position relative to the top of the slider.
     * @return {number} The relative position of the thumb.
     * @private
     */
  }, {
    key: "getRelativePosition_",
    value: function getRelativePosition_(x, y) {
      var amount;
      if (this.direction_ === SliderCommon.Direction_.HORIZONTAL) {
        amount = x / this.widthLimit_();
      } else {
        amount = y / this.heightLimit_();
      }
      return clamp(amount, 0, 1);
    }
  }, {
    key: "setValue",
    value: function setValue(res) {
      res = this.reverse_ ? 1 - res : res;
      this.setThumbPosition_(res);
    }
  }, {
    key: "setEnable",
    value: function setEnable(cond) {
      var elem = this.element;
      if (cond) {
        elem.classList.remove("disable");
      } else {
        elem.classList.add("disable");
      }
      if (control_settings["slider_color"]) {
        var rgb = hexRgb(control_settings["slider_color"]);
        elem.querySelector("button").style.backgroundColor = "rgba(".concat(rgb.red, ",").concat(rgb.green, ",").concat(rgb.blue, ",").concat(cond ? 0.5 : 0.2, ")");
      }
    }
  }], [{
    key: "render",
    value: function render(mapEvent) {
      if (!mapEvent.frameState) {
        return;
      }
      if (!this.sliderInitialized_) {
        this.initSlider_();
      }
    }

    /**
     * The enum for available directions.
     *
     * @enum {number}
     * @private
     */
  }, {
    key: "Direction_",
    get: function get() {
      return {
        VERTICAL: 0,
        HORIZONTAL: 1
      };
    }
  }]);
  return SliderCommon;
}(Control);
export var CustomControl = /*#__PURE__*/function (_Control2) {
  _inherits(CustomControl, _Control2);
  var _super2 = _createSuper(CustomControl);
  function CustomControl(optOptions) {
    var _this2;
    _classCallCheck(this, CustomControl);
    var options = optOptions || {};
    var element = document.createElement("div"); // eslint-disable-line no-undef

    _this2 = _super2.call(this, {
      element: element,
      target: options.target,
      render: options.render
    });
    var button = document.createElement("button"); // eslint-disable-line no-undef
    button.setAttribute("type", "button");
    button.title = options.tipLabel;
    var span = document.createElement("span"); // eslint-disable-line no-undef
    span.innerHTML = options.character;
    button.appendChild(span);
    var timer;
    var touchstart;
    var self = _assertThisInitialized(_this2);
    button.addEventListener("click", function (e) {
      e.stopPropagation();
    });
    button.addEventListener("mouseup", function (e) {
      if (!touchstart) {
        if (timer) {
          if (options.long_callback) {
            clearTimeout(timer); // eslint-disable-line no-undef
          }

          timer = null;
          options.callback.apply(self);
        }
      }
      e.stopPropagation();
    }, false);
    button.addEventListener("mousemove", function (e) {
      e.stopPropagation();
    }, false);
    button.addEventListener("mousedown", function (e) {
      if (!touchstart) {
        if (options.long_callback) {
          timer = setTimeout(function () {
            // eslint-disable-line no-undef
            timer = null;
            options.long_callback.apply(self);
          }, 1500);
        } else {
          timer = true;
        }
      }
      e.stopPropagation();
    }, false);
    button.addEventListener("touchstart", function (e) {
      touchstart = true;
      if (options.long_callback) {
        timer = setTimeout(function () {
          // eslint-disable-line no-undef
          timer = null;
          options.long_callback.apply(self);
        }, 1500);
      } else {
        timer = true;
      }
      e.stopPropagation();
    }, false);
    button.addEventListener("touchend", function (e) {
      if (timer) {
        if (options.long_callback) {
          clearTimeout(timer); // eslint-disable-line no-undef
        }

        timer = null;
        options.callback.apply(self);
      }
      e.stopPropagation();
    }, false);
    button.addEventListener("mouseout", function (e) {
      if (options.long_callback) {
        clearTimeout(timer); // eslint-disable-line no-undef
      }

      timer = null;
      e.stopPropagation();
    }, false);
    button.addEventListener("dblclick", function (e) {
      e.preventDefault();
    }, false);
    element.className = "".concat(options.cls, " ol-unselectable ol-control");
    element.appendChild(button);
    return _this2;
  }
  return _createClass(CustomControl);
}(Control);
export var GoHome = /*#__PURE__*/function (_CustomControl) {
  _inherits(GoHome, _CustomControl);
  var _super3 = _createSuper(GoHome);
  function GoHome(optOptions) {
    var _this3;
    _classCallCheck(this, GoHome);
    var options = optOptions || {};
    options.character = control_settings["home"] ? "<img src=\"".concat(control_settings["home"], "\">") : '<i class=\"fa fa-home fa-lg\"></i>';
    options.cls = "home";
    options.callback = function () {
      var source = this.getMap().getLayers().item(0).getSource();
      source.goHome();
    };
    _this3 = _super3.call(this, options);
    if (control_settings["home"]) {
      var button = _this3.element.querySelector("button");
      button.style.backgroundColor = "rgba(0,0,0,0)";
    }
    return _this3;
  }
  return _createClass(GoHome);
}(CustomControl);
export var SetGPS = /*#__PURE__*/function (_CustomControl2) {
  _inherits(SetGPS, _CustomControl2);
  var _super4 = _createSuper(SetGPS);
  function SetGPS(optOptions) {
    var _this4;
    _classCallCheck(this, SetGPS);
    var options = optOptions || {};
    options.character = control_settings["gps"] ? "<img src=\"".concat(control_settings["gps"], "\">") : '<i class=\"fa fa-crosshairs fa-lg\"></i>';
    options.cls = "gps";
    options.render = function (mapEvent) {
      var frameState = mapEvent.frameState;
      if (!frameState) {
        return;
      }
      var map = this.getMap();
      if (map.geolocation) {
        var tracking = map.geolocation.getTracking();
        var receiving = this.element.classList.contains("disable");
        if (receiving && !tracking) {
          this.element.classList.remove("disable");
        } else if (!receiving && tracking) {
          this.element.classList.add("disable");
        }
      }
    };
    options.callback = function () {
      var receiving = this.element.classList.contains("disable");
      var map = this.getMap();
      map.handleGPS(!receiving);
      if (receiving) {
        this.element.classList.remove("disable");
      } else {
        this.element.classList.add("disable");
      }
    };
    _this4 = _super4.call(this, options);
    if (control_settings["gps"]) {
      var button = _this4.element.querySelector("button");
      button.style.backgroundColor = "rgba(0,0,0,0)";
    }
    return _this4;
  }
  return _createClass(SetGPS);
}(CustomControl);
export var CompassRotate = /*#__PURE__*/function (_Rotate) {
  _inherits(CompassRotate, _Rotate);
  var _super5 = _createSuper(CompassRotate);
  function CompassRotate(optOptions) {
    var _this5;
    _classCallCheck(this, CompassRotate);
    var options = optOptions || {};
    options.autoHide = false;
    var span = document.createElement("span"); // eslint-disable-line no-undef
    span.innerHTML = control_settings["compass"] ? "<img src=\"".concat(control_settings["compass"], "\">") : '<i class=\"fa fa-compass fa-lg ol-compass-fa\"></i>';
    options.label = span;
    options.render = function (mapEvent) {
      var _this6 = this;
      var frameState = mapEvent.frameState;
      if (!frameState) {
        return;
      }
      var view = this.getMap().getView();
      var rotation = frameState.viewState.rotation;
      var center = view.getCenter();
      var zoom = view.getDecimalZoom();
      if (rotation != this.rotation_ || center[0] != this.center_[0] || center[1] != this.center_[1] || zoom != this.zoom_) {
        if (!this.getMap().northUp) {
          var contains = this.element.classList.contains("disable");
          if (!contains && rotation === 0) {
            this.element.classList.add("disable");
          } else if (contains && rotation !== 0) {
            this.element.classList.remove("disable");
          }
        }
        var self = this;
        var layer = this.getMap().getLayers().item(0);
        var source = layer.getSource ? layer.getSource() : layer.getLayers().item(0).getSource();
        if (!source) {
          var transform = "rotate(0rad)";
          self.label_.style.msTransform = transform;
          self.label_.style.webkitTransform = transform;
          self.label_.style.transform = transform;
          return;
        }
        source.viewpoint2MercsAsync().then(function (mercs) {
          var direction = source.mercs2MercViewpoint(mercs)[2];
          var transform = "rotate(".concat(direction, "rad)");
          self.label_.style.msTransform = transform;
          self.label_.style.webkitTransform = transform;
          self.label_.style.transform = transform;
          if (_this6.getMap().northUp) {
            console.log(direction);
            var _contains = self.element.classList.contains("disable");
            if (!_contains && Math.abs(direction) < 0.1) {
              self.element.classList.add("disable");
            } else if (_contains && Math.abs(direction) >= 0.1) {
              self.element.classList.remove("disable");
            }
          }
        });
      }
      this.rotation_ = rotation;
      this.center_ = center;
      this.zoom_ = zoom;
    };
    _this5 = _super5.call(this, options);
    if (control_settings["compass"]) {
      var button = _this5.element.querySelector("button");
      button.style.backgroundColor = "rgba(0,0,0,0)";
    }
    _this5.center_ = [];
    _this5.zoom_ = undefined;
    _this5.callResetNorth_ = function () {
      var layer = _this5.getMap().getLayers().item(0);
      var source = layer.getSource ? layer.getSource() : layer.getLayers().item(0).getSource();
      source.resetCirculation();
    };
    return _this5;
  }
  return _createClass(CompassRotate);
}(Rotate);
export var Share = /*#__PURE__*/function (_CustomControl3) {
  _inherits(Share, _CustomControl3);
  var _super6 = _createSuper(Share);
  function Share(optOptions) {
    var _this7;
    _classCallCheck(this, Share);
    var options = optOptions || {};
    options.character = control_settings["share"] ? "<img src=\"".concat(control_settings["share"], "\">") : '<i class=\"fa fa-share-alt-square fa-lg\"></i>';
    options.cls = "ol-share";
    options.callback = function () {
      var map = this.getMap();
      map.dispatchEvent(new MapEvent("click_control", map, {
        control: "share"
      }));
    };
    _this7 = _super6.call(this, options);
    if (control_settings["share"]) {
      var button = _this7.element.querySelector("button");
      button.style.backgroundColor = "rgba(0,0,0,0)";
    }
    return _this7;
  }
  return _createClass(Share);
}(CustomControl);
export var Border = /*#__PURE__*/function (_CustomControl4) {
  _inherits(Border, _CustomControl4);
  var _super7 = _createSuper(Border);
  function Border(optOptions) {
    var _this8;
    _classCallCheck(this, Border);
    var options = optOptions || {};
    options.character = control_settings["border"] ? "<img src=\"".concat(control_settings["border"], "\">") : '<i class=\"fa fa-clone fa-lg\"></i>';
    options.cls = "ol-border";
    options.callback = function () {
      var map = this.getMap();
      map.dispatchEvent(new MapEvent("click_control", map, {
        control: "border"
      }));
    };
    _this8 = _super7.call(this, options);
    if (control_settings["border"]) {
      var button = _this8.element.querySelector("button");
      button.style.backgroundColor = "rgba(0,0,0,0)";
    }
    return _this8;
  }
  return _createClass(Border);
}(CustomControl);
export var Maplat = /*#__PURE__*/function (_CustomControl5) {
  _inherits(Maplat, _CustomControl5);
  var _super8 = _createSuper(Maplat);
  function Maplat(optOptions) {
    var _this9;
    _classCallCheck(this, Maplat);
    var options = optOptions || {};
    options.character = control_settings["help"] ? "<img src=\"".concat(control_settings["help"], "\">") : '<i class=\"fa fa-question-circle fa-lg\"></i>';
    options.cls = "ol-maplat";
    options.callback = function () {
      var map = this.getMap();
      map.dispatchEvent(new MapEvent("click_control", map, {
        control: "help"
      }));
    };
    _this9 = _super8.call(this, options);
    if (control_settings["help"]) {
      var button = _this9.element.querySelector("button");
      button.style.backgroundColor = "rgba(0,0,0,0)";
    }
    return _this9;
  }
  return _createClass(Maplat);
}(CustomControl);
export var Copyright = /*#__PURE__*/function (_CustomControl6) {
  _inherits(Copyright, _CustomControl6);
  var _super9 = _createSuper(Copyright);
  function Copyright(optOptions) {
    var _this10;
    _classCallCheck(this, Copyright);
    var options = optOptions || {};
    options.character = control_settings["attr"] ? "<img src=\"".concat(control_settings["attr"], "\">") : '<i class=\"fa fa-info-circle fa-lg\"></i>';
    options.cls = "ol-copyright";
    options.callback = function () {
      var map = this.getMap();
      map.dispatchEvent(new MapEvent("click_control", map, {
        control: "copyright"
      }));
    };
    _this10 = _super9.call(this, options);
    if (control_settings["attr"]) {
      var button = _this10.element.querySelector("button");
      button.style.backgroundColor = "rgba(0,0,0,0)";
    }
    return _this10;
  }
  return _createClass(Copyright);
}(CustomControl);
export var HideMarker = /*#__PURE__*/function (_CustomControl7) {
  _inherits(HideMarker, _CustomControl7);
  var _super10 = _createSuper(HideMarker);
  function HideMarker(optOptions) {
    var _this11;
    _classCallCheck(this, HideMarker);
    var options = optOptions || {};
    options.character = control_settings["hide_marker"] ? "<img src=\"".concat(control_settings["hide_marker"], "\">") : '<i class=\"fa fa-map-marker fa-lg\"></i>';
    options.cls = "ol-hide-marker";
    options.callback = function () {
      var map = this.getMap();
      map.dispatchEvent(new MapEvent("click_control", map, {
        control: "hideMarker"
      }));
    };
    options.long_callback = function () {
      var map = this.getMap();
      map.dispatchEvent(new MapEvent("click_control", map, {
        control: "hideLayer"
      }));
    };
    _this11 = _super10.call(this, options);
    if (control_settings["hide_marker"]) {
      var button = _this11.element.querySelector("button");
      button.style.backgroundColor = "rgba(0,0,0,0)";
    }
    return _this11;
  }
  return _createClass(HideMarker);
}(CustomControl);
export var Zoom = /*#__PURE__*/function (_BaseZoom) {
  _inherits(Zoom, _BaseZoom);
  var _super11 = _createSuper(Zoom);
  function Zoom() {
    var _this12;
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, Zoom);
    if (control_settings["zoom_plus"]) {
      options.zoomInLabel = createElement("<img src=\"".concat(control_settings["zoom_plus"], "\">"))[0];
    }
    if (control_settings["zoom_minus"]) {
      options.zoomOutLabel = createElement("<img src=\"".concat(control_settings["zoom_minus"], "\">"))[0];
    }
    _this12 = _super11.call(this, options);
    if (control_settings["compass"]) {
      var buttons = _this12.element.querySelectorAll("button");
      buttons.forEach(function (button) {
        button.style.backgroundColor = "rgba(0,0,0,0)";
      });
    }
    return _this12;
  }
  return _createClass(Zoom);
}(BaseZoom);